import React from "react";

const About = () => {
  return (
    <div name="about" className="w-full md:h-screen bg-[#0a192f] text-gray-300">
      <div className="flex flex-col justify-center items-center w-full h-full">
        <div className="max-w-[1000px] w-full grid grid-cols-2 gap-8">
          <div className="sm:text-right pb-8 pl-4">
            <p className="text-4xl font-bold inline border-b-4 border-pink-600">
              About
            </p>
          </div>
          <div></div>
        </div>
        <div className="max-w-[1000px] w-full grid sm:grid-cols-2 gap-8 px-4">
          <div className="sm:text-right text-4xl font-bold">
            <p>
              Hi. I'm Vinay Saladi, nice to meet you. Please take a look around.
            </p>
          </div>
          <div>
            <p>
              I specialize in the development of applications using the ReactJS
              library and have a strong understanding of JavaScript and web
              development principles. I have experience with front-end
              technologies such as HTML, CSS, and DOM manipulation, and am
              skilled at implementing functionalities using ReactJS. In my
              previous roles, I have successfully maintained and updated
              existing applications, and have always prided myself on my
              problem-solving and communication skills. I am excited to continue
              my growth as a ReactJS developer and am always looking for new
              opportunities to learn and improve.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
